// packages/shared/src/types.ts
// ---------------------------------------------------------------------------
// WebSocket Collaboration Protocol
// ---------------------------------------------------------------------------
/**
 * Binary WebSocket message type tags (first byte of each Binary Frame).
 * AUTH and AUTH_OK use JSON Text Frames and are NOT in this enum.
 */
export var WSMessageType;
(function (WSMessageType) {
    WSMessageType[WSMessageType["SCENE_UPDATE"] = 2] = "SCENE_UPDATE";
    WSMessageType[WSMessageType["CURSOR_UPDATE"] = 3] = "CURSOR_UPDATE";
    WSMessageType[WSMessageType["USER_CHANGE"] = 4] = "USER_CHANGE";
    WSMessageType[WSMessageType["FIRST_IN_ROOM"] = 5] = "FIRST_IN_ROOM";
    WSMessageType[WSMessageType["SCENE_REQUEST"] = 6] = "SCENE_REQUEST";
    WSMessageType[WSMessageType["SCENE_PUSH"] = 7] = "SCENE_PUSH";
    WSMessageType[WSMessageType["SAVE_ACK"] = 8] = "SAVE_ACK";
    WSMessageType[WSMessageType["SAVE_REQUEST"] = 9] = "SAVE_REQUEST";
    WSMessageType[WSMessageType["SAVE_FAILED"] = 10] = "SAVE_FAILED";
})(WSMessageType || (WSMessageType = {}));
export function isWSMessageType(value) {
    return value >= WSMessageType.SCENE_UPDATE && value <= WSMessageType.SAVE_FAILED;
}
// ---------------------------------------------------------------------------
// Binary Frame Helpers — shared between frontend and backend
// ---------------------------------------------------------------------------
/** Create a binary WebSocket frame: [type: 1 byte] [payload: rest] */
export function createBinaryFrame(type, payload) {
    const frame = new Uint8Array(1 + payload.length);
    frame[0] = type;
    frame.set(payload, 1);
    return frame;
}
/** Parse a binary WebSocket frame into type tag and payload */
export function parseBinaryFrame(data) {
    if (data.length === 0) {
        throw new Error("Empty binary frame");
    }
    if (!isWSMessageType(data[0])) {
        throw new Error("Unknown binary frame type");
    }
    return { type: data[0], payload: data.subarray(1) };
}
//# sourceMappingURL=types.js.map